<template>
  <v-menu
      close-on-click
      close-on-content-click
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="my-2">
          <v-btn
            v-bind="attrs"
            v-on="on"
            aria-label="Abrir menú de cuenta"
          >
            <v-icon class="mr-2" aria-hidden="true">mdi-account-circle-outline</v-icon>
            <span class="d-none d-sm-inline">Cuenta</span>
          </v-btn>
        </div>
      </template>
      <v-list>
        <v-list-item v-if="isAuthenticated">
          {{oidcUser.name}}
        </v-list-item>
        <v-list-item
          v-for="(item, index) in menuItems"
          :key="index"
          @click="item.action"
        >
          <v-list-item-icon class="mr-2">
            <v-icon aria-hidden="true">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'oidcIsAuthenticated',
      'oidcUser'
    ]),
    isAuthenticated(){
      return this.oidcIsAuthenticated
    },
    menuItems(){
      if(this.isAuthenticated){
        return [
          { title: 'Mi cuenta', icon: 'mdi-account-outline', action: this.profile },
          { title: 'Cerrar sesión', icon: 'mdi-logout', action: this.logout }
        ]
      }

      return [
        { title: 'Iniciar sesión', icon: 'mdi-login', action: this.login },
        { title: 'Crear cuenta', icon: 'mdi-account-plus-outline', action: this.signup }
      ]
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('signOutOidcSilent')
      this.$store.commit('setUserRole',undefined)
      this.$router.push('/')
    },
    login(){
      this.$store.dispatch('authenticateOidc')
    },
    profile(){
      this.$router.push('/self')
    },
    signup(){
      this.$router.push('/users/new')      
    }
  }
}
</script>

<style scoped>
.v-btn{box-shadow:none!important;text-transform:none!important;letter-spacing:0!important;color:#173347!important;font-size:12px;font-weight:700}
</style>
